var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
var PasswordChecking = function PasswordChecking(_ref) { var password = _ref.password, rule = _ref.rule; var _useTranslation = useTranslation(), t = _useTranslation.t; var _useState = useState(__spreadArray([], __read(rule.map(function (e) { return e.regex.test(password); })), false)), ruleState = _useState[0], setRuleState = _useState[1]; useEffect(function () { setRuleState(__spreadArray([], __read(rule.map(function (e) { return password !== "" && password != null && e.regex.test(password); })), false)); }, [rule, password]); return /*#__PURE__*/ React.createElement("div", { className: "text-left" }, /*#__PURE__*/ React.createElement("div", { className: "text-black-100 text-sm mt-8" }, t("newPasswordRequire")), /*#__PURE__*/ React.createElement("div", { className: "flex flex-col w-full" }, ruleState.map(function (result, index) { var _rule$index; return /*#__PURE__*/ React.createElement("div", { className: "flex flex-row w-full " + (result ? "text-green-60" : "text-black-90") + " ", key: index }, /*#__PURE__*/ React.createElement("div", { className: "h-6 w-6 flex justify-center items-center text-center mr-2" }, /*#__PURE__*/ React.createElement("i", { className: "text-2xl font-black " + (result ? "i-tick" : "i-minus") })), /*#__PURE__*/ React.createElement("div", null, (_rule$index = rule[index]) === null || _rule$index === void 0 ? void 0 : _rule$index.title)); }))); };
export default PasswordChecking;
